export default __webpack_public_path__ + "static/media/visibility_off_black.af3e7a5e.svg";